import { useQuery } from "@tanstack/react-query"

import useOnRouteChangeComplete from "../../routes/useOnRouteChangeComplete"
import loginApi from "./loginApi"

const useLoginStatusQuery = (enabled = true) => {
  const { data: isLoggedIn, refetch, isLoading } = useQuery(["loginApi.loginStatus"], loginApi.loginStatus, {
    enabled,
    select(result) {
      return result.isSuccess && result.data.login
    },
  })

  useOnRouteChangeComplete(refetch)

  return { isLoggedIn, isLoading }
}

export default useLoginStatusQuery
